var map = {
	"./arrow-left.svg": "d704",
	"./arrow-right.svg": "9e2e",
	"./check-bold.svg": "1c95",
	"./check-circle-s.svg": "3a26",
	"./close.svg": "d866",
	"./copy.svg": "0490",
	"./credit-card.svg": "72b9",
	"./delete.svg": "d0c6",
	"./denied.svg": "f511",
	"./discount.svg": "1145",
	"./down.svg": "8597",
	"./download.svg": "019a",
	"./gift.svg": "8165",
	"./info-circle.svg": "b686",
	"./left.svg": "d6d3",
	"./loading.svg": "f14f",
	"./logout.svg": "090a",
	"./mail.svg": "c6b2",
	"./minus.svg": "e747",
	"./photo-in-frame.svg": "5b1d",
	"./plus.svg": "521e",
	"./receipt.svg": "b485",
	"./reedem.svg": "e625",
	"./right.svg": "b698",
	"./selfie.svg": "80c4",
	"./shopping-bag.svg": "c4a5",
	"./shopping-cart.svg": "4a65",
	"./video.svg": "a4a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec0d";